import { AgxSpacer, AgxTypography, AutopilotMarkLogo } from '@urbanx/agx.ui-components2';

import { NewFormButton } from '../NewFormButton';
import './CampaignEmptyState.scss';

const CampaignEmptyState = () => {
  return (
    <AgxSpacer
      className="campaign-empty-state"
      contentAlignment="center"
      fill
      padding="spacing-4xl"
    >
      <AgxSpacer
        gap="spacing-5xl"
        contentAlignment="center"
        padding={{
          top: 'spacing-7xl',
          bottom: 'spacing-7xl',
          left: 'spacing-5xl',
          right: 'spacing-5xl',
        }}
      >
        <AgxSpacer padding="spacing-3xl">
          <AutopilotMarkLogo width={48} height={34} outline="black" toggle="lime" />
        </AgxSpacer>

        <AgxSpacer
          gap="spacing-3xl"
          contentAlignment="center"
          padding={{ left: 'spacing-8xl', right: 'spacing-8xl' }}
        >
          <AgxTypography
            id="campaign-empty-state-title"
            type="body_ui_strong"
            size="medium"
            textAlign="center"
          >
            Get started.
          </AgxTypography>
          <AgxTypography
            id="campaign-empty-state-description"
            type="body_ui"
            size="small"
            color="var(--text-secondary)"
            textAlign="center"
          >
            Create your first campaign by starting a New Agreement.
          </AgxTypography>
        </AgxSpacer>

        <NewFormButton id="campaign-empty-state-new-agreement" />
      </AgxSpacer>
    </AgxSpacer>
  );
};

export default CampaignEmptyState;
